module.exports = __webpack_public_path__ + "media/images/icons/twotone/audio-b3b7d1583f21a9de01d170e5d1391cf5.svg";